import type { TranslationKey } from "./en";

const fr: Partial<Record<TranslationKey, string>> = {
  "lang.label": "Langue",
  "lang.select": "Choisir la langue",
  "theme.toggle": "Changer de thème",
  "theme.light": "Mode clair",
  "theme.dark": "Mode sombre",
  "brand.name": "GuardAI par G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "Patrouille de sécurité",
  "brand.guardSystem": "Système de gardiennage",
  "console.director": "Console directeur",
  "console.admin": "Console administrateur",
  "console.supervisor": "Console superviseur",
  "role.administrator": "Administrateur",
  "role.director": "Directeur",
  "role.supervisor": "Superviseur",
  "role.guard": "Agent de sécurité",
  "nav.dashboard": "Tableau de bord",
  "nav.liveActivity": "Activité en direct",
  "nav.devices": "Appareils",
  "nav.schedules": "Plannings",
  "nav.calendar": "Calendrier",
  "nav.alerts": "Alertes",
  "nav.checkpoints": "Points de contrôle",
  "nav.reports": "Rapports",
  "nav.reportBuilder": "Générateur de rapports",
  "nav.askAi": "Interroger l'IA",
  "nav.admin": "Administration",
  "nav.settings": "Paramètres",
  "nav.deploy": "Déploiement",
  "nav.scanMap": "Carte des scans",
  "nav.users": "Gestion des utilisateurs",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.submit": "Soumettre",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.search": "Rechercher",
  "common.filter": "Filtrer",
  "common.export": "Exporter",
  "common.clear": "Effacer",
  "common.viewAll": "Tout afficher",
  "common.back": "Retour",
  "common.close": "Fermer",
  "common.confirm": "Confirmer",
  "common.add": "Ajouter",
  "common.refresh": "Actualiser",
  "common.loading": "Chargement…",
  "common.saving": "Enregistrement…",
  "common.saved": "Enregistré",
  "common.error": "Erreur",
  "common.noData": "Aucune donnée",
  "common.required": "Obligatoire",
  "common.optional": "Facultatif",
  "common.yes": "Oui",
  "common.no": "Non",
  "common.all": "Tous",
  "common.none": "Aucun",
  "common.name": "Nom",
  "common.status": "Statut",
  "common.location": "Emplacement",
  "common.time": "Heure",
  "common.date": "Date",
  "common.actions": "Actions",
  "common.today": "aujourd'hui",
  "domain.scanEvent": "Événement de scan",
  "domain.scanEvents": "Événements de scan",
  "domain.checkpoint": "Point de contrôle",
  "domain.checkpoints": "Points de contrôle",
  "domain.hospital": "Hôpital",
  "domain.hospitals": "Hôpitaux",
  "domain.guard": "Agent",
  "domain.guards": "Agents",
  "domain.device": "Appareil",
  "domain.devices": "Appareils",
  "domain.patrol": "Patrouille",
  "domain.security": "Sécurité",
  "domain.shift": "Service",
  "domain.station": "Poste",
  "search.placeholder": "Rechercher des agents, des emplacements ou des scans…",
  "notif.title": "Notifications",
  "notif.empty": "Aucune nouvelle notification",
  "notif.viewAll": "Voir toutes les notifications",
  "notif.missedCheckpoint": "Alerte de point de contrôle manqué",
  "status.active": "Actif",
  "status.inactive": "Inactif",
  "status.online": "En ligne",
  "status.offline": "Hors ligne",
  "status.pending": "En attente",
  "status.approved": "Approuvé",
  "status.denied": "Refusé",
  "status.flagged": "Signalé",
  "status.completed": "Terminé",
  "status.missed": "Manqué",
  "status.onDuty": "En service",
  "status.offDuty": "Hors service",
  "auth.signIn": "Se connecter",
  "auth.signingIn": "Connexion…",
  "auth.signOut": "Se déconnecter",
  "auth.username": "Nom d'utilisateur",
  "auth.password": "Mot de passe",
  "auth.loginFailed": "Échec de la connexion",
  "auth.tagline": "Les agents de sécurité scannent leur badge à n'importe quel poste et les superviseurs voient les mises à jour instantanément sur un tableau de bord sécurisé.",
  "dashboard.title": "Centre de patrouille de sécurité",
  "dashboard.subtitle": "Surveillance en temps réel de chaque point de contrôle",
  "dashboard.totalScans": "Total des scans",
  "dashboard.activeGuards": "Agents actifs",
  "dashboard.checkpoints": "Points de contrôle",
  "dashboard.openAlerts": "Alertes ouvertes",
  "dashboard.recentActivity": "Activité récente",
  "dashboard.noActivity": "Aucune activité récente",
  "live.title": "Activité de patrouille en direct",
  "live.subtitle": "Un flux en temps réel de chaque scan de badge au moment où il se produit",
  "live.empty": "Aucune activité pour le moment",
  "live.waiting": "En attente du prochain scan…",
  "devices.title": "Appareils de patrouille connectés",
  "devices.subtitle": "État de chaque appareil de scan sur le terrain",
  "devices.lastSeen": "Vu pour la dernière fois",
  "devices.battery": "Batterie",
  "devices.none": "Aucun appareil connecté",
  "schedules.title": "Plannings de patrouille",
  "schedules.subtitle": "Affecter des agents aux services et aux points de contrôle",
  "schedules.addShift": "Ajouter un service",
  "schedules.none": "Aucun planning pour le moment",
  "alerts.title": "Alertes de sécurité",
  "alerts.subtitle": "Points de contrôle manqués et événements signalés nécessitant une attention",
  "alerts.none": "Aucune alerte active",
  "alerts.allClear": "Tout est en ordre — rien ne nécessite d'attention.",
  "alerts.acknowledge": "Accuser réception",
  "alerts.resolve": "Résoudre",
  "reports.title": "Rapports de sécurité",
  "reports.subtitle": "Couverture des patrouilles, volume de scans et analyses d'intégrité",
  "reports.builderTitle": "Générateur de rapports",
  "reports.builderSubtitle": "Concevez des rapports professionnels — aucun code requis.",
  "reports.generate": "Générer le rapport",
  "reports.noData": "Aucune donnée pour ce rapport",
  "ask.title": "Interroger l'IA",
  "ask.greeting": "Comment puis-je vous aider aujourd'hui ?",
  "ask.placeholder": "Posez toute question sur vos patrouilles, vos agents ou vos scans…",
  "ask.send": "Envoyer",
  "ask.thinking": "Réflexion…",
  "admin.title": "Administration du système",
  "admin.subtitle": "Gérer les accès, les approbations et l'état du système",
  "admin.pendingApplications": "Demandes en attente",
  "admin.systemHealth": "État du système",
  "admin.uptime": "Disponibilité",
  "admin.storage": "Stockage",
  "admin.users": "Utilisateurs",
  "admin.latency": "Latence",
  "users.title": "Gestion des utilisateurs",
  "users.subtitle": "Ajouter, modifier et désactiver les comptes de la plateforme",
  "users.addUser": "Ajouter un utilisateur",
  "users.none": "Aucun utilisateur trouvé",
  "settings.title": "Paramètres",
  "settings.subtitle": "Gérer votre compte et vos préférences",
  "settings.account": "Compte",
  "settings.appearance": "Apparence",
  "settings.notifications": "Notifications",
  "settings.language": "Langue",
  "deploy.title": "Planificateur de déploiement",
  "deploy.subtitle": "Planifier, capturer et vérifier l'emplacement des points de contrôle",
  "deploy.plan": "Planifier",
  "deploy.capture": "Capturer",
  "deploy.verify": "Vérifier",
  "map.title": "Carte des scans",
  "map.subtitle": "Où les scans de badge ont lieu dans l'établissement",
  "map.noScans": "Aucun scan à afficher",
  "profile.account": "Compte",
  "profile.settings": "Paramètres",
  "profile.help": "Aide et assistance",
  "profile.darkMode": "Mode sombre",
  "profile.viewProfile": "Voir le profil",
  "footer.copyright": "© 2026 G-Data Labs. Tous droits réservés.",
  "footer.terms": "Conditions d'utilisation",
  "footer.privacy": "Politique de confidentialité",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "Ajouter un agent",
  "admin.addNewGuard": "Ajouter un nouvel agent",
  "admin.addRoute": "Ajouter un itinéraire",
  "admin.alertEmail": "E-mail de notification d'alerte",
  "admin.avgResponse": "Réponse moyenne",
  "admin.checkpointTimeout": "Délai d'expiration du point de contrôle (minutes)",
  "admin.checkpointsCount": "Points de contrôle ({n})",
  "admin.colBadge": "Badge",
  "admin.colContact": "Contact",
  "admin.colGuard": "Agent",
  "admin.colLastActive": "Dernière activité",
  "admin.colRole": "Rôle",
  "admin.colRoutes": "Itinéraires",
  "admin.deactivatedPreviewDesc": "Voici comment un compte désactivé apparaît aux administrateurs.",
  "admin.deactivatedPreviewTitle": "Aperçu d'un agent désactivé",
  "admin.difficultyEasy": "Facile",
  "admin.difficultyHard": "Difficile",
  "admin.difficultyMedium": "Moyen",
  "admin.employeeId": "ID employé :",
  "admin.errorAddGuard": "Impossible d'ajouter l'agent. Veuillez réessayer.",
  "admin.errorAllFields": "Tous les champs sont obligatoires.",
  "admin.errorLoadDirectory": "Impossible de charger l'annuaire des agents pour le moment.",
  "admin.fieldEmail": "E-mail",
  "admin.fieldEmergencyContact": "Contact d'urgence",
  "admin.fieldEmployeeId": "ID employé Emory",
  "admin.fieldFullName": "Nom complet",
  "admin.fieldPhone": "Téléphone",
  "admin.fieldRole": "Rôle",
  "admin.fieldTempPassword": "Mot de passe temporaire",
  "admin.gpsThreshold": "Seuil de précision GPS (mètres)",
  "admin.guardId": "ID de l'agent :",
  "admin.loadingDirectory": "Chargement de l'annuaire des agents…",
  "admin.moreCheckpoints": "+{n} points de contrôle supplémentaires",
  "admin.noGuards": "Aucun agent trouvé. Ajoutez votre premier agent pour commencer.",
  "admin.noRoutesAssigned": "Aucun itinéraire attribué",
  "admin.notGenerated": "Non généré",
  "admin.passwordPolicy": "Politique de mots de passe",
  "admin.passwordPolicyDesc": "Imposer des mots de passe forts",
  "admin.patrolRoutes": "Itinéraires de patrouille",
  "admin.placeholderTempPassword": "Définir un mot de passe temporaire",
  "admin.resetSessions": "Réinitialiser toutes les sessions",
  "admin.roleAdmin": "Administrateur",
  "admin.roleDirector": "Directeur",
  "admin.roleGuard": "Agent",
  "admin.roleSupervisor": "Superviseur",
  "admin.saveConfiguration": "Enregistrer la configuration",
  "admin.searchGuards": "Rechercher des agents...",
  "admin.securitySettings": "Paramètres de sécurité",
  "admin.sessionTimeout": "Expiration de la session",
  "admin.sessionTimeoutDesc": "Déconnexion automatique après inactivité",
  "admin.statusDeactivated": "Désactivé",
  "admin.statusLabel": "Statut :",
  "admin.statusSuspended": "Suspendu",
  "admin.storageUsed": "Stockage utilisé",
  "admin.systemConfiguration": "Configuration du système",
  "admin.systemStatus": "État du système",
  "admin.tabBadges": "Générateur de badges",
  "admin.tabGuards": "Gestion des agents",
  "admin.tabRoutes": "Gestion des itinéraires",
  "admin.tabSettings": "Paramètres du système",
  "admin.timeout1Hour": "1 heure",
  "admin.timeout2Hours": "2 heures",
  "admin.timeout30Min": "30 minutes",
  "admin.timeout4Hours": "4 heures",
  "admin.totalScans": "Total des scans",
  "admin.twoFactor": "Authentification à deux facteurs",
  "admin.twoFactorDesc": "Exiger la 2FA pour tous les superviseurs",
  "admin.viewBadge": "Voir le badge",
  "alerts.acknowledged": "Prise en compte",
  "alerts.activeAlerts": "Alertes actives",
  "alerts.allLocationsHealthy": "Tous les emplacements sont sains",
  "alerts.allPriorities": "Toutes les priorités",
  "alerts.allStatus": "Tous les statuts",
  "alerts.allTypes": "Tous les types",
  "alerts.apiError": "Erreur d'API",
  "alerts.assignedTo": "Attribuée à :",
  "alerts.critical": "Critique",
  "alerts.distanceAway": "à {n} m",
  "alerts.exportTitle": "Exporter les données d'alertes",
  "alerts.filters": "Filtres",
  "alerts.guardLabel": "Agent {name}",
  "alerts.high": "Élevée",
  "alerts.invalidScan": "Scan non valide",
  "alerts.issuesDetected": "{n} problèmes détectés",
  "alerts.loadFailed": "Échec du chargement des alertes",
  "alerts.loadFailedHint": "vérifiez que le point de terminaison des alertes est déployé.",
  "alerts.loadingAlerts": "Chargement des alertes...",
  "alerts.low": "Faible",
  "alerts.medium": "Moyenne",
  "alerts.noInvalidScans": "Aucun scan non valide dans le dernier lot.",
  "alerts.noneMatchFilters": "Aucune alerte ne correspond à vos filtres",
  "alerts.refreshTitle": "Actualiser les alertes",
  "alerts.resolved": "Résolue",
  "alerts.scanExceptions": "Anomalies de scan de patrouille",
  "alerts.scanExceptionsSubtitle": "Scans non valides ou erreurs d'API provenant des appareils de terrain",
  "alerts.tryAgain": "Réessayer",
  "alerts.typeEmergency": "Urgence",
  "alerts.typeMissedCheckpoint": "Point de contrôle manqué",
  "alerts.typeSystem": "Système",
  "alerts.unknownGuard": "inconnu",
  "ask.accessDenied": "Accès refusé",
  "ask.accessDeniedDesc": "La fonctionnalité Demander à l'IA est réservée aux administrateurs.",
  "ask.askNow": "Demander",
  "ask.askedTimesOne": "Posée {n} fois",
  "ask.askedTimesOther": "Posée {n} fois",
  "ask.closeHistory": "Fermer l'historique",
  "ask.dateAtTime": "{date} à {time}",
  "ask.encryptedPrivate": "Analyse chiffrée et confidentielle",
  "ask.errorMessage": "Désolé, je n'ai pas pu traiter cette question. Cela peut être dû à un problème de connexion ou à une requête non prise en charge. Veuillez reformuler votre question ou réessayer dans un instant.",
  "ask.exampleInvalidScans": "Quels emplacements ont enregistré le plus de scans NON VALIDES cette semaine ?",
  "ask.exampleMissedScans": "Montrez-moi les agents ayant manqué 3 scans ou plus au cours des 7 derniers jours.",
  "ask.exampleNoScansToday": "Listez les emplacements n'ayant reçu aucun scan aujourd'hui.",
  "ask.exampleOvernightScans": "Combien de scans ont été enregistrés pendant la nuit entre 22h00 et 06h00 ?",
  "ask.frequentlyAsked": "Questions fréquentes",
  "ask.hideSql": "Masquer la requête SQL",
  "ask.history": "Historique",
  "ask.inputPlaceholder": "Posez une question comme « Quels emplacements ont eu le moins de scans hier ? »",
  "ask.noHistory": "Pas encore d'historique. Posez une question pour commencer.",
  "ask.noQueriesMatching": "Aucune requête correspondant à « {q} »",
  "ask.rowCountOne": "{n} ligne",
  "ask.rowCountOther": "{n} lignes",
  "ask.searchPlaceholder": "Rechercher des requêtes passées...",
  "ask.showSql": "Afficher la requête SQL",
  "ask.subtitle": "Posez des questions sur la conformité des patrouilles, les points de contrôle manqués, les performances des agents ou les tendances par emplacement.",
  "ask.tagline": "Fondé sur les données de patrouille en temps réel",
  "ask.thisWeek": "Cette semaine",
  "ask.today": "Aujourd'hui",
  "ask.yesterday": "Hier",
  "auth.applyToJoin": "Postulez pour rejoindre notre équipe",
  "auth.email": "E-mail",
  "auth.enterCredentials": "Saisissez vos identifiants pour accéder au système.",
  "auth.needAccess": "Besoin d'accéder au système de sécurité ?",
  "deploy.addFloor": "+ Étage",
  "deploy.addUnplannedCheckpoint": "Ajouter un point de contrôle non planifié",
  "deploy.address": "Adresse",
  "deploy.allSaved": "Tout est enregistré",
  "deploy.area": "Zone",
  "deploy.areaDescription": "Zone / description",
  "deploy.areaLabel": "Zone :",
  "deploy.areaPlaceholder": "Entrée des urgences, Suite administrative 200…",
  "deploy.areaSuite": "Zone / Suite",
  "deploy.cameraError": "Erreur de caméra :",
  "deploy.cancelScan": "Annuler le scan",
  "deploy.captureWalkthrough": "Parcours de capture",
  "deploy.capturedProgress": "{done} / {total} capturés",
  "deploy.checkpointsCount": "Points de contrôle ({n})",
  "deploy.ckStatusCaptured": "capturé",
  "deploy.ckStatusInstalled": "installé",
  "deploy.ckStatusPlanned": "planifié",
  "deploy.ckStatusVerified": "vérifié",
  "deploy.clickAnywhereToPlace": "Cliquez n'importe où pour placer le repère",
  "deploy.clickFloorPlan": "Cliquez sur le plan…",
  "deploy.complete": "Terminé !",
  "deploy.completionReport": "Rapport d'achèvement",
  "deploy.contactLabel": "Contact :",
  "deploy.contactPhone": "Téléphone du contact",
  "deploy.createAndCapture": "Créer et capturer",
  "deploy.createProject": "Créer le projet",
  "deploy.creating": "Création…",
  "deploy.dismiss": "ignorer",
  "deploy.editingCheckpoint": "Modification du point de contrôle",
  "deploy.fileFormats": "PNG, JPG ou PDF",
  "deploy.floor": "Étage",
  "deploy.floorColon": "Étage :",
  "deploy.floorLabel": "Étage :",
  "deploy.floorN": "Étage {n}",
  "deploy.floorPlanAlt": "Plan de l'étage {n}",
  "deploy.generated": "Généré :",
  "deploy.gettingGps": "Obtention du GPS…",
  "deploy.gpsFailedRetry": "Échec du GPS — réessayer",
  "deploy.grabGps": "Capturer le GPS",
  "deploy.hospitalNameRequired": "Nom de l'hôpital *",
  "deploy.initials": "Initiales : ______",
  "deploy.installVerify": "Installer et vérifier",
  "deploy.installedAlt": "installé",
  "deploy.installedVerifiedProgress": "{done} / {total} installés et vérifiés",
  "deploy.locationDetail": "Détail de l'emplacement",
  "deploy.locationDetailPlaceholder": "À gauche des portes principales, au-dessus du gel hydroalcoolique…",
  "deploy.locationDetailShort": "À gauche des portes principales…",
  "deploy.locationLabel": "Emplacement :",
  "deploy.markInstalledVerified": "Marquer comme installé et vérifié",
  "deploy.newCheckpoint": "Nouveau point de contrôle",
  "deploy.newDeploymentProject": "Nouveau projet de déploiement",
  "deploy.newProject": "Nouveau projet",
  "deploy.newUnplannedCheckpoint": "Nouveau point de contrôle non planifié",
  "deploy.noCameraFound": "Aucune caméra trouvée",
  "deploy.noCheckpointsHint": "Cliquez sur « Placer un repère » puis sur le plan.",
  "deploy.noCheckpointsYet": "Aucun point de contrôle pour l'instant.",
  "deploy.noProjectSelected": "Aucun projet sélectionné",
  "deploy.noProjectSelectedHint": "Sélectionnez un projet existant ou créez-en un nouveau ci-dessus.",
  "deploy.noProjectsYet": "Aucun projet pour l'instant.",
  "deploy.notYetVerified": "Pas encore vérifiés",
  "deploy.notes": "Notes",
  "deploy.notesLabel": "Notes :",
  "deploy.notesPlaceholder": "Notes de repère, détails de montage…",
  "deploy.placeCardHere": "Placez la carte ICI (d'après la capture) :",
  "deploy.placeMarker": "Placer un repère",
  "deploy.placementNotes": "Notes de placement",
  "deploy.placementNotesPlaceholder": "1,5 m de haut, mur en brique, adhésif permanent…",
  "deploy.placementReferenceAlt": "référence de placement",
  "deploy.print": "Imprimer",
  "deploy.printChecklist": "Imprimer la liste de contrôle",
  "deploy.qrPlaced": "QR placé",
  "deploy.qrPrefix": "QR :",
  "deploy.recapture": "Recapturer",
  "deploy.retakeInstalledPhoto": "Reprendre la photo d'installation",
  "deploy.retakePhoto": "Reprendre la photo",
  "deploy.reverify": "Revérifier",
  "deploy.saveCapture": "Enregistrer la capture",
  "deploy.scanAgain": "Scanner à nouveau",
  "deploy.scanQrCode": "Scanner le code QR",
  "deploy.scanToVerify": "Scanner pour vérifier",
  "deploy.scanVerified": "Scan vérifié",
  "deploy.scannedPrefix": "Scanné :",
  "deploy.selectProject": "Sélectionner un projet…",
  "deploy.selectProjectShort": "Sélectionner un projet…",
  "deploy.selectProjectToCapture": "Sélectionnez un projet pour commencer la capture.",
  "deploy.selectProjectToVerify": "Sélectionnez un projet pour commencer la vérification.",
  "deploy.simulation3d": "Simulation 3D",
  "deploy.siteContactName": "Nom du contact sur site",
  "deploy.speechNotSupported": "La reconnaissance vocale n'est pas prise en charge par ce navigateur.",
  "deploy.statusCapturing": "capture",
  "deploy.statusComplete": "terminé",
  "deploy.statusFabricating": "fabrication",
  "deploy.statusInstalling": "installation",
  "deploy.statusPlanning": "planification",
  "deploy.stop": "Arrêt",
  "deploy.stopNumber": "Arrêt n° {n}",
  "deploy.stopVoice": "Arrêter",
  "deploy.takeInstalledPhoto": "Prendre la photo d'installation",
  "deploy.takePhoto": "Prendre une photo",
  "deploy.total": "Total",
  "deploy.unnamed": "Sans nom",
  "deploy.unnamedLower": "sans nom",
  "deploy.unsavedChanges": "Modifications non enregistrées...",
  "deploy.uploadFloorPlan": "Téléverser le plan",
  "deploy.uploadFloorPlanFor": "Téléversez un plan pour l'étage {n}",
  "deploy.uuidMatched": "UUID correspond ! QR vérifié.",
  "deploy.uuidMismatch": "UUID incorrect. Mauvaise carte QR.",
  "deploy.uuidPrefix": "UUID :",
  "deploy.verifiedCheckpoints": "Points de contrôle vérifiés",
  "deploy.verifiedCount": "Vérifiés",
  "deploy.voice": "Voix",
  "deploy.walkthroughChecklistStops": "Liste de contrôle du parcours de déploiement — {n} arrêts",
  "devices.appVersion": "Version de l'application",
  "devices.deviceManagement": "Gestion des appareils",
  "devices.emptyHint": "Les appareils connectés apparaîtront ici dès qu'ils enverront des données de télémétrie.",
  "devices.geofences": "Géorepères",
  "devices.hoursAgo": "il y a {n} h",
  "devices.justNow": "À l'instant",
  "devices.lastLocation": "Dernière position",
  "devices.locateOnMap": "Localiser l'appareil sur la carte",
  "devices.minutesAgo": "il y a {n} min",
  "devices.never": "Jamais",
  "devices.noDevicesFound": "Aucun appareil trouvé",
  "devices.noGpsData": "Aucune donnée GPS",
  "devices.refreshStatus": "Actualiser l'état",
  "devices.violations": "Infractions",
  "geofence.acknowledge": "Confirmer",
  "geofence.acknowledged": "Confirmée",
  "geofence.acknowledging": "Confirmation...",
  "geofence.actionHeader": "Action",
  "geofence.allGeofences": "Toutes les géofences",
  "geofence.create": "Créer une géofence",
  "geofence.createdBy": "Créé par",
  "geofence.createdDate": "Date de création",
  "geofence.deleteConfirmBody": "Cette action est irréversible. La géofence sera définitivement supprimée.",
  "geofence.deleteConfirmTitle": "Supprimer la géofence ?",
  "geofence.drawPolygon": "Dessiner un polygone sur la carte",
  "geofence.drawPolygonHint": "Cliquez sur la carte pour ajouter des points. Le polygone doit comporter au moins 3 points. Points actuels : {n}",
  "geofence.edit": "Modifier la géofence",
  "geofence.enterName": "Veuillez saisir un nom de géofence",
  "geofence.failedCreate": "Échec de la création de la géofence",
  "geofence.failedDelete": "Échec de la suppression de la géofence",
  "geofence.failedLoad": "Échec du chargement des géofences",
  "geofence.failedSave": "Échec de l'enregistrement de la géofence",
  "geofence.failedUpdate": "Échec de la mise à jour de la géofence",
  "geofence.filterByGeofence": "Filtrer par géofence",
  "geofence.geofenceHeader": "Géofence",
  "geofence.gpsCoordinates": "Coordonnées GPS",
  "geofence.hoursAgo": "il y a {n} h",
  "geofence.justNow": "À l'instant",
  "geofence.management": "Gestion des géofences",
  "geofence.managementSubtitle": "Définissez des zones sécurisées et surveillez les violations de périmètre",
  "geofence.minPoints": "Le polygone doit comporter au moins 3 points",
  "geofence.minutesAgo": "il y a {n} min",
  "geofence.nameLabel": "Nom de la géofence",
  "geofence.namePlaceholder": "ex. : Entrée principale, Parking A",
  "geofence.noViolations": "Aucune violation détectée",
  "geofence.noViolationsHint": "Tous les appareils se trouvent dans leurs géofences désignées.",
  "geofence.noneConfigured": "Aucune géofence n'est configurée pour votre emplacement.",
  "geofence.noneYet": "Aucune géofence pour l'instant",
  "geofence.noneYetCanCreate": "Créez votre première géofence pour commencer la surveillance des périmètres.",
  "geofence.pointN": "Point {n} :",
  "geofence.polygonPoints": "Points du polygone ({n})",
  "geofence.preview": "Aperçu",
  "geofence.save": "Enregistrer la géofence",
  "geofence.selectHospitalAlert": "Veuillez sélectionner un hôpital",
  "geofence.selectHospitalOption": "Sélectionner un hôpital...",
  "geofence.unacknowledged": "Non confirmée",
  "geofence.unacknowledgedCount": "{n} non confirmées",
  "geofence.violationsSubtitle": "Surveillez et accusez réception des violations de périmètre",
  "geofence.violationsTitle": "Violations de géofences",
  "help.callNow": "Appeler maintenant",
  "help.comingSoon": "Bientôt disponible",
  "help.docsComingSoon": "Documentation à venir.",
  "help.emailSupport": "Assistance par e-mail",
  "help.escalateIssue": "Faire remonter le problème",
  "help.guardHeadline": "Aide et assistance pour les agents",
  "help.guidesFaq": "Guides et FAQ",
  "help.incidentEscalation": "Escalade d'incident",
  "help.incidentEscalationDesc": "Signalez les pannes, les défaillances de borne ou les problèmes de scan urgents.",
  "help.intro": "Contactez l'équipe de la patrouille de sécurité d'Emory ou consultez les étapes de dépannage rapides.",
  "help.phoneHotline": "Ligne d'assistance téléphonique",
  "help.phoneHotlineValue": "(404) 555-0199 • 24h/24 et 7j/7",
  "help.quickTips": "Conseils rapides",
  "help.sendEmail": "Envoyer un e-mail",
  "help.supervisorHeadline": "Aide et assistance pour les superviseurs",
  "help.support": "Assistance",
  "help.tipAskAi": "Utilisez la page Demander à l'IA pour extraire des données historiques avant de contacter l'assistance.",
  "help.tipRefresh": "Actualisez la page si les scans semblent retardés ou obsolètes.",
  "help.tipReinstall": "Les agents peuvent réinstaller la PWA via la page Paramètres lorsque l'icône disparaît.",
  "home.activeCheckpoints": "Points de contrôle actifs",
  "home.activeCheckpointsTooltip": "Nombre total d'emplacements physiques de codes QR actuellement enregistrés dans cet hôpital.",
  "home.addNewMarker": "Ajouter un nouveau marqueur",
  "home.allHospitalsAggregated": "Tous les hôpitaux (agrégés)",
  "hospitals.allAggregated": "Tous les hôpitaux (agrégés)",
  "home.building": "Bâtiment",
  "home.buildingFloor": "{building} - Étage {floor}",
  "home.cancelPlacement": "Annuler le placement",
  "home.chartScans": "Scans :",
  "home.checkpointName": "Nom du point de contrôle",
  "home.checkpointNamePlaceholder": "p. ex. Finances (Ouest)",
  "home.checkpointsScanned": "Points de contrôle scannés",
  "home.chooseCheckpoint": "— Choisir un point de contrôle —",
  "home.cleared": "VALIDÉ",
  "home.clickToPlace": "Cliquez n'importe où sur la carte pour placer un nouveau marqueur.",
  "home.comparingScanVolume": "Comparaison du volume de scans actifs sur tous les sites enregistrés",
  "home.complianceRate": "Taux de conformité",
  "home.complianceRateTooltip": "Pourcentage de points de contrôle enregistrés qui ont été scannés au moins une fois pendant le quart de travail actuel.",
  "home.complianceRateValue": "Taux de conformité : {n}%",
  "home.confirmDeleteCheckpoint": "Êtes-vous sûr de vouloir supprimer ce point de contrôle ? Cette action est irréversible.",
  "home.createCustomCheckpoint": "+ Créer un point de contrôle personnalisé...",
  "home.deleteMarker": "Supprimer le marqueur",
  "home.dragToReposition": "Faites glisser les marqueurs pour les repositionner. Les modifications sont enregistrées automatiquement.",
  "home.editModeOn": "Mode édition ACTIVÉ",
  "home.editPositions": "Modifier les positions",
  "home.failedDeleteLocation": "Échec de la suppression de l'emplacement",
  "home.failedSaveLocation": "Échec de l'enregistrement de l'emplacement",
  "home.floor": "Étage",
  "home.floorAbbr": "Ét. {n}",
  "home.floorN": "Étage {n}",
  "home.headerSubtitle": "Vérification des patrouilles en temps réel et statut de téléversement du concentrateur",
  "home.hospitalPerformanceComparison": "Comparaison des performances des hôpitaux",
  "home.hospitalSecurity": "Sécurité de l'hôpital",
  "home.hub": "Concentrateur : {hub}",
  "home.internalServerError": "Erreur interne du serveur",
  "home.lastHour": "Dernière heure",
  "home.lastScan": "Dernier scan",
  "home.lastUpdated": "Dernière mise à jour :",
  "home.legendError": "Erreur",
  "home.legendInvalid": "Non valide",
  "home.legendOk": "OK",
  "home.liveSystem": "Système en direct",
  "home.loadingCheckpoints": "Chargement des points de contrôle...",
  "home.loadingComplianceData": "Chargement des données de conformité...",
  "home.loadingUploads": "Chargement des téléversements...",
  "home.mapLast30Days": "30 derniers jours",
  "home.mapLast7Days": "7 derniers jours",
  "home.mapLastQuarter": "Dernier trimestre",
  "home.mapSubtitle": "Suivi des patrouilles en temps réel et statut des points de contrôle",
  "home.mapTitle": "Carte d'activité en direct de l'hôpital",
  "home.mapTodaysScans": "Scans d'aujourd'hui",
  "home.moreCheckpoints": "+ {n} points de contrôle supplémentaires",
  "home.noCheckpointsConfigured": "Aucun point de contrôle configuré pour cet hôpital.",
  "home.noCheckpointsLoaded": "Aucun point de contrôle chargé. Vérifiez la connexion à la base de données ou ajoutez-en un manuellement ci-dessous.",
  "home.noUploadsToday": "Aucun téléversement enregistré aujourd'hui.",
  "home.numberOfScans": "Nombre de scans",
  "home.pendingClear": "VALIDATION EN ATTENTE",
  "home.placeCheckpoint": "Placer un point de contrôle",
  "home.positionLabel": "Position :",
  "home.qrPayload": "Charge utile QR",
  "home.qrPayloadPlaceholder": "p. ex. FINANCE_WEST",
  "home.recentPatrolActivity7Days": "Activité de patrouille récente (7&nbsp;jours)",
  "home.recentScans7Days": "Scans récents (7&nbsp;jours)",
  "home.recentScansTooltip": "Nombre total de scans de patrouille téléversés et vérifiés avec succès au cours des 7 derniers jours.",
  "home.registeredCheckpoints": "Points de contrôle enregistrés",
  "home.roleDashboard": "Tableau de bord {role} :",
  "home.saveCheckpoint": "Enregistrer le point de contrôle",
  "home.scanner": "Scanner : {serial}",
  "home.scansCount": "{n} scans",
  "home.selectCheckpoint": "Sélectionner un point de contrôle",
  "home.tooltipPosition": "Position",
  "home.unknownHospital": "Hôpital inconnu",
  "home.uploadsByShift": "Téléversements par quart",
  "home.viewingHospital": "Hôpital affiché :",
  "landing.addressInfo": "Informations sur l'adresse",
  "landing.agreeTerms": "J'accepte les conditions d'utilisation",
  "landing.agreeTermsDetail": "Je comprends que l'accès au système de patrouille de sécurité est subordonné à l'approbation d'un superviseur et que toutes les informations fournies sont exactes et complètes.",
  "landing.availableShifts": "Quarts disponibles (sélectionnez tous ceux qui s'appliquent)",
  "landing.bulletIntegrity": "Analyses d'intégrité pour les scans manqués et les événements signalés.",
  "landing.bulletMonitoring": "Surveillance en temps réel de chaque hall, entrée et couloir.",
  "landing.bulletWorkspace": "Espace de travail unifié pour superviseurs avec recherche instantanée et analyses par IA.",
  "landing.city": "Ville",
  "landing.completeAndAgree": "Veuillez remplir tous les champs obligatoires et accepter les conditions.",
  "landing.confirmPassword": "Confirmer le mot de passe",
  "landing.confirmYourPassword": "Confirmez votre mot de passe",
  "landing.createPassword": "Créez un mot de passe sécurisé",
  "landing.dateOfBirth": "Date de naissance",
  "landing.emailAddress": "Adresse e-mail",
  "landing.emailRegistered": "Cette adresse e-mail est déjà enregistrée.",
  "landing.emailRegisteredUseDifferent": "Cette adresse e-mail est déjà enregistrée. Veuillez utiliser une autre adresse e-mail.",
  "landing.emergencyContact": "Contact d'urgence",
  "landing.emergencyContactName": "Nom du contact d'urgence",
  "landing.emergencyContactPhone": "Téléphone du contact d'urgence",
  "landing.fillRequiredContinue": "Veuillez remplir tous les champs obligatoires avant de continuer.",
  "landing.firstName": "Prénom",
  "landing.lastName": "Nom",
  "landing.next": "Suivant",
  "landing.passwordsNoMatch": "Les mots de passe ne correspondent pas",
  "landing.percentComplete": "{p}% terminé",
  "landing.personalInfo": "Informations personnelles",
  "landing.phoneNumber": "Numéro de téléphone",
  "landing.phoneRegistered": "Ce numéro de téléphone est déjà enregistré.",
  "landing.phoneRegisteredUseDifferent": "Ce numéro de téléphone est déjà enregistré. Veuillez utiliser un autre numéro de téléphone.",
  "landing.relChild": "Enfant",
  "landing.relFriend": "Ami(e)",
  "landing.relOther": "Autre",
  "landing.relParent": "Parent",
  "landing.relSibling": "Frère/Sœur",
  "landing.relSpouse": "Conjoint(e)",
  "landing.relationship": "Lien de parenté",
  "landing.requestAccessSubtitle": "Remplissez ce formulaire pour demander l'accès au système de patrouille de sécurité.",
  "landing.requestAccessTitle": "Demander l'accès au système",
  "landing.requestSubmitted": "Demande de compte envoyée",
  "landing.requestSubmittedApproval": "Vous pourrez vous connecter avec vos identifiants une fois la demande approuvée. Ce processus prend généralement 1 à 2 jours ouvrables.",
  "landing.requestSubmittedThanks": "Merci d'avoir demandé l'accès au système de patrouille de sécurité. Votre demande a été envoyée et est en attente d'approbation par les superviseurs.",
  "landing.requestedRole": "Rôle demandé",
  "landing.returnHome": "Retour à l'accueil",
  "landing.returnToLogin": "Retour à la connexion",
  "landing.roleAvailability": "Rôle et disponibilité",
  "landing.securityDirector": "Directeur de la sécurité",
  "landing.securitySupervisor": "Superviseur de sécurité",
  "landing.selectEllipsis": "Sélectionner...",
  "landing.shiftDay": "Quart de jour (6h-14h)",
  "landing.shiftEvening": "Quart du soir (14h-22h)",
  "landing.shiftHolidays": "Jours fériés",
  "landing.shiftNight": "Quart de nuit (22h-6h)",
  "landing.shiftOnCall": "Sur appel",
  "landing.shiftWeekends": "Week-ends",
  "landing.signInSubheading": "Utilisez vos identifiants de superviseur ou d'agent pour continuer.",
  "landing.signInToGuard": "Se connecter à Guard",
  "landing.somethingWrong": "Une erreur s'est produite.",
  "landing.state": "État",
  "landing.stepOf": "Étape {n} sur 4",
  "landing.streetAddress": "Adresse",
  "landing.submitApplication": "Envoyer la demande",
  "landing.submitFailed": "Échec de l'envoi de la demande. Veuillez réessayer.",
  "landing.submitting": "Envoi en cours...",
  "landing.termsOfService": "Conditions d'utilisation",
  "landing.zipCode": "Code postal",
  "live.action": "Action",
  "live.activityFeed": "Flux d'activité",
  "live.asOf": "À {time}",
  "live.colCoordinate": "Coordonnée",
  "live.colDateTime": "Date et heure",
  "live.colDistance": "Distance",
  "live.deviceLocation": "(Position de l'appareil)",
  "live.filterAll": "Toute l'activité",
  "live.filterInvalid": "Scans non valides",
  "live.filterValid": "Scans valides",
  "live.floor": "Étage {n}",
  "live.freshFix": "(Position récente)",
  "live.loadingActivity": "Chargement de l'activité de patrouille…",
  "live.metersAway": "à {n} m",
  "live.noGpsData": "Aucune donnée GPS",
  "live.noScansFilter": "Aucun scan ne correspond à ce filtre.",
  "live.syncData": "Synchroniser les données",
  "live.timeframe": "Période",
  "live.unknownHospital": "Hôpital inconnu",
  "live.unknownLocation": "Emplacement inconnu",
  "live.view3d": "Vue 3D",
  "live.view3dWorld": "Voir le monde 3D de ce point de contrôle",
  "map.allHospitals": "Tous les hôpitaux",
  "map.autoRefresh": "Actualisation auto",
  "map.autoRefreshTitle": "Actualisation automatique toutes les 30 s",
  "map.dark": "Sombre",
  "map.expandLegend": "Développer la légende",
  "map.gpsDisclaimer": "Les positions des scans reflètent la précision GPS de l'appareil. Les signaux en intérieur peuvent varier de 10 à 50 m par rapport à l'emplacement réel.",
  "map.heatmap": "Carte de chaleur",
  "map.heatmapTitle": "Activer/désactiver la carte de densité",
  "map.legend": "Légende",
  "map.light": "Clair",
  "map.limitedWarning": "La carte affiche au maximum {max} scans. Veuillez affiner la plage horaire ou le filtre d'hôpital pour voir des données précises.",
  "map.loadFailed": "Échec du chargement des scans",
  "map.loadingScans": "Chargement des scans…",
  "map.mapStyle": "Style de carte : {name}",
  "map.markers": "Marqueurs",
  "map.minimizeLegend": "Réduire la légende",
  "map.noGpsScans": "Aucun scan géolocalisé trouvé pour cette plage horaire.",
  "map.pageSubtitle": "Vue géographique en direct des lieux où les scans ont eu lieu.",
  "map.pageTitle": "Carte des scans GuardAI",
  "map.popupHospital": "Hôpital :",
  "map.popupScanner": "Scanner :",
  "map.popupTime": "Heure :",
  "map.rangeCustom": "Plage personnalisée",
  "map.rangeLast24h": "Dernières 24 h",
  "map.rangeLast30d": "30 derniers jours",
  "map.rangeLast7d": "7 derniers jours",
  "map.rangeLastHour": "Dernière heure",
  "map.showingMaxScans": "Affichage de {shown} (max) sur {total} scans",
  "map.snapToBuilding": "Aligner sur le bâtiment",
  "map.snapToBuildingTitle": "Aligne les points GPS vers le centre des bâtiments pour compenser la dérive GPS en intérieur",
  "map.switchToDark": "Passer à la carte sombre",
  "map.switchToLight": "Passer à la carte claire",
  "map.to": "à",
  "map.totalScans": "{total} scans",
  "map.unknownHospital": "Inconnu",
  "map.updatedAt": "Mis à jour {time}",
  "reportBuilder.addWidget": "Ajouter un widget",
  "reportBuilder.aiAssistant": "Assistant de rapports IA",
  "reportBuilder.aiPlaceholder": "Décrivez le rapport souhaité — par ex. « nombre de scans par hôpital pour le dernier mois avec un graphique à barres ». Ou esquissez une mise en page sur papier et téléchargez une photo.",
  "reportBuilder.aiSummaryHint": "Cliquez sur « Générer » pour rédiger des observations à partir des données de votre rapport.",
  "reportBuilder.allHospitals": "Tous les hôpitaux",
  "reportBuilder.allTime": "Toute la période",
  "reportBuilder.assistantUnavailable": "L’assistant est indisponible pour le moment.",
  "reportBuilder.author": "Auteur",
  "reportBuilder.beta": "Bêta",
  "reportBuilder.buildItForMe": "Créez-le pour moi",
  "reportBuilder.buildTogether": "Construisons-le ensemble",
  "reportBuilder.canvasEmpty": "Votre canevas est vide",
  "reportBuilder.canvasEmptyHint": "Ajoutez un widget depuis la barre d’outils ci-dessus, cliquez sur un champ de données à gauche ou partez d’un modèle.",
  "reportBuilder.captionPlaceholder": "Légende (facultatif)",
  "reportBuilder.color": "Couleur",
  "reportBuilder.compareAgainst": "Comparer avec",
  "reportBuilder.configure": "Configurer",
  "reportBuilder.copySuffix": "(copie)",
  "reportBuilder.couldntSave": "Échec de l’enregistrement :",
  "reportBuilder.dataFields": "Champs de données",
  "reportBuilder.dataFieldsHint": "Cliquez sur un champ pour ajouter un widget prêt à l’emploi à votre rapport.",
  "reportBuilder.dataSource": "Source de données",
  "reportBuilder.dateFrom": "À partir du {date}",
  "reportBuilder.dateFromLabel": "Date de début",
  "reportBuilder.dateThrough": "Jusqu’au {date}",
  "reportBuilder.dateToLabel": "Date de fin",
  "reportBuilder.dayOfWeekOpt": "Jour de la semaine",
  "reportBuilder.describeOrSketch": "Décrivez le rapport souhaité ou joignez un croquis.",
  "reportBuilder.dismiss": "Ignorer",
  "reportBuilder.done": "Terminé",
  "reportBuilder.donutStyle": "Style anneau",
  "reportBuilder.draftedOffline": " · rédigé hors ligne",
  "reportBuilder.duplicate": "Dupliquer",
  "reportBuilder.example1": "Nombre de scans par hôpital pour le dernier mois, avec un graphique à barres",
  "reportBuilder.example2": "Activité de patrouille quotidienne avec heures de pointe et appareils actifs",
  "reportBuilder.example3": "Couverture des points de contrôle : scannés vs non scannés par hôpital",
  "reportBuilder.exportCsv": "CSV (données)",
  "reportBuilder.exportFailed": "Échec de l’exportation :",
  "reportBuilder.exportHtml": "HTML (partageable)",
  "reportBuilder.exportPdf": "PDF (prêt à imprimer)",
  "reportBuilder.exportPng": "Image PNG",
  "reportBuilder.exportPrint": "Imprimer",
  "reportBuilder.exportSlides": "Prêt pour diapositives (HTML)",
  "reportBuilder.exportTryPdf": "Essayez plutôt PDF (Impression).",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "Titre",
  "reportBuilder.filterFloor": "Filtre : étage",
  "reportBuilder.filterHospital": "Filtre : hôpital",
  "reportBuilder.floorPlaceholder": "p. ex. L1, 5, Plaza",
  "reportBuilder.generate": "Générer",
  "reportBuilder.generateBtn": "Générer",
  "reportBuilder.generatedBy": "Généré par GuardAI · © {year} G-Data Labs. Tous droits réservés.",
  "reportBuilder.generating": "Génération…",
  "reportBuilder.group": "Groupe",
  "reportBuilder.groupBy": "Grouper par",
  "reportBuilder.hideSettings": "Masquer les paramètres",
  "reportBuilder.horizontal": "horizontal",
  "reportBuilder.imageTooLarge": "Cette image est un peu volumineuse — veuillez en utiliser une de moins de 6 Mo.",
  "reportBuilder.imageUrlPlaceholder": "URL de l’image (facultatif)",
  "reportBuilder.includeLogo": "Inclure le logo GuardAI",
  "reportBuilder.loadFailed": "Impossible de charger les données.",
  "reportBuilder.lookAt": "Regardez le {target}",
  "reportBuilder.maxRows": "Lignes max.",
  "reportBuilder.metric": "Métrique",
  "reportBuilder.moreSettings": "Plus de paramètres",
  "reportBuilder.moveDown": "Déplacer vers le bas",
  "reportBuilder.moveUp": "Déplacer vers le haut",
  "reportBuilder.next": "Suivant",
  "reportBuilder.noDataSelection": "Aucune donnée pour cette sélection",
  "reportBuilder.noImageUploaded": "Aucune image téléchargée",
  "reportBuilder.noLayout": "Je n’ai pas pu en faire une mise en page — essayez de décrire les métriques et leur regroupement.",
  "reportBuilder.noSummary": "Aucun résumé généré.",
  "reportBuilder.noWidgetsYet": "Ce rapport n’a pas encore de widgets.",
  "reportBuilder.optionalSubtitle": "Sous-titre facultatif",
  "reportBuilder.orientation": "Orientation",
  "reportBuilder.period": "Période : {range}",
  "reportBuilder.preparedBy": "Préparé par {name}",
  "reportBuilder.preview": "Aperçu",
  "reportBuilder.previewHint": "Voici comment votre rapport sera exporté et imprimé. Utilisez le bouton Exporter ci-dessus pour le télécharger.",
  "reportBuilder.regenerate": "Régénérer",
  "reportBuilder.remove": "Supprimer",
  "reportBuilder.removeImage": "Supprimer l’image",
  "reportBuilder.reportImage": "Image du rapport",
  "reportBuilder.reportTitle": "Titre du rapport",
  "reportBuilder.reportsAnalytics": "Rapports et analyses",
  "reportBuilder.saveAsTemplate": "Enregistrer le rapport actuel comme modèle partagé",
  "reportBuilder.savedAt": "Enregistré à {time}",
  "reportBuilder.savedReports": "Rapports enregistrés",
  "reportBuilder.secondSeriesLabel": "Libellé de la deuxième série",
  "reportBuilder.secondSeriesMetric": "Métrique de la deuxième série",
  "reportBuilder.secondSeriesSource": "Source de la deuxième série",
  "reportBuilder.selectWidget": "Sélectionnez un widget pour le configurer.",
  "reportBuilder.seriesB": "Série B",
  "reportBuilder.sketch": "Croquis",
  "reportBuilder.sketchAlt": "croquis",
  "reportBuilder.sort": "Trier",
  "reportBuilder.sortLabelAsc": "Nom, A → Z",
  "reportBuilder.sortLabelDesc": "Nom, Z → A",
  "reportBuilder.sortValueAsc": "Valeur, faible → élevée",
  "reportBuilder.sortValueDesc": "Valeur, élevée → faible",
  "reportBuilder.startFromTemplate": "Partir d’un modèle",
  "reportBuilder.startNewReport": "Démarrer un nouveau rapport",
  "reportBuilder.stepOf": "Étape {n} sur {total}",
  "reportBuilder.subtitle": "Sous-titre",
  "reportBuilder.summaryFailed": "Échec de la génération du résumé.",
  "reportBuilder.targetAiBar": "barre de l’assistant IA",
  "reportBuilder.targetCanvas": "canevas du rapport",
  "reportBuilder.targetConfigPanel": "panneau de configuration",
  "reportBuilder.targetDataFields": "panneau des champs de données",
  "reportBuilder.targetExport": "bouton Exporter",
  "reportBuilder.targetPreview": "bascule d’aperçu",
  "reportBuilder.targetSave": "bouton Enregistrer",
  "reportBuilder.targetTemplates": "bouton Modèles",
  "reportBuilder.targetToolbar": "barre d’outils des widgets",
  "reportBuilder.templates": "Modèles",
  "reportBuilder.textPlaceholder": "Rédigez votre texte. Utilisez ## pour un titre et **gras** pour la mise en évidence.",
  "reportBuilder.thinking": "Réflexion…",
  "reportBuilder.title": "Générateur de rapports",
  "reportBuilder.total": "Total",
  "reportBuilder.try": "Essayez :",
  "reportBuilder.untitledReport": "Rapport sans titre",
  "reportBuilder.uploadSketchTitle": "Téléchargez une photo d’une mise en page de rapport dessinée à la main",
  "reportBuilder.vertical": "vertical",
  "reportBuilder.walkMeThrough": "Guidez-moi pas à pas",
  "reportBuilder.widgetCountMany": "{n} widgets",
  "reportBuilder.widgetCountOne": "{n} widget",
  "reportBuilder.width": "Largeur",
  "reportBuilder.widthFull": "Pleine",
  "reportBuilder.working": "Traitement…",
  "reports.activeGuards": "Gardes actifs",
  "reports.asOfTime": "(au {time})",
  "reports.averageCompliance": "Conformité moyenne",
  "reports.averageResponseTime": "Temps de réponse moyen",
  "reports.checkpointLocationAnalysis": "Analyse des emplacements des points de contrôle",
  "reports.checkpointsCompleted": "Points de contrôle effectués",
  "reports.checkpointsLoggedGps": "({n} points de contrôle enregistrés à partir des données GPS)",
  "reports.colCompliance": "Conformité",
  "reports.colPerformance": "Performance",
  "reports.compliance90to94": "90-94% de conformité",
  "reports.compliance95": "≥95% de conformité",
  "reports.complianceBelow90": "<90% de conformité",
  "reports.complianceLabel": "conformité",
  "reports.complianceReport": "Rapport de conformité",
  "reports.coverageComplianceHelp": "% de points de contrôle visités au moins une fois pendant cette période",
  "reports.coverageComplianceTrends": "Tendances de conformité de couverture",
  "reports.criticalIssuesResolved": "Problèmes critiques résolus",
  "reports.currentTime": "Actuel : {time}",
  "reports.dayFri": "Ven",
  "reports.dayFriday": "Vendredi",
  "reports.dayMon": "Lun",
  "reports.dayMonday": "Lundi",
  "reports.daySat": "Sam",
  "reports.daySaturday": "Samedi",
  "reports.daySun": "Dim",
  "reports.daySunday": "Dimanche",
  "reports.dayThu": "Jeu",
  "reports.dayThursday": "Jeudi",
  "reports.dayTue": "Mar",
  "reports.dayTuesday": "Mardi",
  "reports.dayWed": "Mer",
  "reports.dayWednesday": "Mercredi",
  "reports.deltaLastMonth": "+1,8% par rapport au mois dernier",
  "reports.deltaLastQuarter": "+3,2% par rapport au trimestre dernier",
  "reports.deltaLastWeek": "+2,1% par rapport à la semaine dernière",
  "reports.deltaYesterday": "+1,5% par rapport à hier",
  "reports.downloadReport": "Télécharger le rapport",
  "reports.exceptions": "Exceptions",
  "reports.exportFormat": "Format d'exportation",
  "reports.exportReport": "Exporter le rapport",
  "reports.guardPerformanceAnalysis": "Analyse de la performance des gardes",
  "reports.heatmapCellTitle": "{location} - {label} : {pct}% d'activité",
  "reports.lessActivity": "Moins d'activité",
  "reports.loadingPatrolActivity": "Chargement de l'activité de patrouille…",
  "reports.locationAbbreviations": "Abréviations des emplacements :",
  "reports.locationActivityHeatmap": "Carte de chaleur d'activité par emplacement",
  "reports.missedCheckpoints": "Points de contrôle manqués",
  "reports.missedCount": "{n} manqués",
  "reports.monFeb": "Févr",
  "reports.monJan": "Janv",
  "reports.monMar": "Mars",
  "reports.monthN": "Mois {n}",
  "reports.moreActivity": "Plus d'activité",
  "reports.noChange": "Aucun changement",
  "reports.noCoverageData": "Aucune donnée de couverture pour l'instant",
  "reports.noDataForPeriod": "Aucune donnée pour la période",
  "reports.noScanLocations": "Aucun emplacement de scan de code QR disponible",
  "reports.notAvailable": "N/D",
  "reports.overallComplianceRate": "Taux de conformité global",
  "reports.patrolLocations": "Lieux de patrouille",
  "reports.periodMonth": "Ce mois-ci",
  "reports.periodQuarter": "Ce trimestre",
  "reports.periodToday": "Aujourd'hui",
  "reports.periodWeek": "Cette semaine",
  "reports.popupCompliance": "Conformité :",
  "reports.popupLast": "Dernier :",
  "reports.popupScans": "Scans :",
  "reports.qrScanLocations": "Emplacements de scan des codes QR",
  "reports.quickExportOptions": "Options d'exportation rapide",
  "reports.realScanData": "Données de scan réelles (dernières 24 h)",
  "reports.scanToSeeLocations": "Scannez des codes QR pour voir les emplacements sur la carte",
  "reports.scansCount": "{n} scans",
  "reports.scansThisMonth": "{n} scans ce mois-ci",
  "reports.scansThisQuarter": "{n} scans ce trimestre",
  "reports.scansThisWeek": "{n} scans cette semaine",
  "reports.scansToday": "{n} scans aujourd'hui",
  "reports.tabCompliance": "Conformité",
  "reports.tabGuardPerformance": "Performance des gardes",
  "reports.tabLocationAnalysis": "Analyse des emplacements",
  "reports.tabOverview": "Aperçu",
  "reports.totalScans": "Total des scans",
  "reports.trackingLocationsGuards": "Suivi de {locations} emplacements et {guards} gardes.",
  "reports.trendDaily": "Tendances de performance quotidiennes",
  "reports.trendHourly": "Tendances de performance horaires",
  "reports.trendMonthly": "Tendances de performance mensuelles",
  "reports.trendTooltip": "{pct}% ({n} empl.)",
  "reports.trendWeekly": "Tendances de performance hebdomadaires",
  "reports.validated": "Validés",
  "reports.viewDetails": "Voir les détails",
  "reports.weekN": "Semaine {n}",
  "reports.weeklySummary": "Résumé hebdomadaire",
  "reports.wk1": "Sem1",
  "reports.wk2": "Sem2",
  "reports.wk3": "Sem3",
  "reports.wk4": "Sem4",
  "schedules.activeRoutes": "Itinéraires actifs",
  "schedules.activeSchedules": "Plannings actifs",
  "schedules.addNewSchedule": "Ajouter un nouveau planning",
  "schedules.addSchedule": "Ajouter un planning",
  "schedules.assignedGuard": "Agent assigné",
  "schedules.assignedGuards": "Agents assignés",
  "schedules.calendar": "Calendrier",
  "schedules.confirmDelete": "Voulez-vous vraiment supprimer ce planning ?",
  "schedules.coverageGaps": "Lacunes de couverture",
  "schedules.createSchedule": "Créer un planning",
  "schedules.dayFri": "Ven",
  "schedules.dayMon": "Lun",
  "schedules.daySat": "Sam",
  "schedules.daySun": "Dim",
  "schedules.dayThu": "Jeu",
  "schedules.dayTue": "Mar",
  "schedules.dayWed": "Mer",
  "schedules.daysOfWeek": "Jours de la semaine",
  "schedules.deleteSchedule": "Supprimer le planning",
  "schedules.editSchedule": "Modifier le planning",
  "schedules.endTime": "Heure de fin",
  "schedules.fillRequired": "Veuillez remplir tous les champs obligatoires",
  "schedules.frequency": "Fréquence",
  "schedules.frequencyCustom": "Personnalisé",
  "schedules.frequencyDaily": "Quotidien",
  "schedules.frequencyWeekly": "Hebdomadaire",
  "schedules.listView": "Vue liste",
  "schedules.morningPatrol": "Patrouille du matin",
  "schedules.nightShift": "Quart de nuit",
  "schedules.route": "Itinéraire",
  "schedules.scheduleName": "Nom du planning",
  "schedules.scheduleNamePlaceholder": "ex. : Patrouille du matin - Bâtiment A",
  "schedules.selectGuard": "Sélectionner un agent",
  "schedules.selectRoute": "Sélectionner un itinéraire",
  "schedules.selectedCount": "Sélectionnés : {n} point(s) de contrôle",
  "schedules.startTime": "Heure de début",
  "schedules.updateSchedule": "Mettre à jour le planning",
  "settings.browserDesc": "UA enregistré pour surveiller l'intégrité de l'appareil.",
  "settings.browserLabel": "Navigateur",
  "settings.cameraDesc": "Requis pour scanner les étiquettes QR. Ajustez dans les paramètres système si refusé.",
  "settings.cameraPermission": "Autorisation de la caméra",
  "settings.deviceIdDesc": "Empreinte enregistrée avec chaque scan à des fins de conformité d'audit.",
  "settings.deviceIdLabel": "ID de l'appareil",
  "settings.email": "E-mail",
  "settings.escalationAlerts": "Alertes d'escalade",
  "settings.fullName": "Nom complet",
  "settings.installPwa": "Installer en tant que PWA",
  "settings.locationDesc": "Requis pour la vérification GPS à chaque point de contrôle.",
  "settings.locationPermission": "Autorisation de localisation",
  "settings.mobilePhone": "Téléphone portable",
  "settings.notRegistered": "Pas encore enregistré",
  "settings.notificationDesc": "Contrôlez les alertes que l'équipe de supervision peut vous envoyer.",
  "settings.notificationPreferences": "Préférences de notification",
  "settings.permGranted": "Accordé",
  "settings.permUnknown": "Inconnu",
  "settings.profileDetails": "Détails du profil",
  "settings.profileSavedMsg": "Préférences du profil enregistrées. Les modifications prennent effet immédiatement.",
  "settings.pwaAndroid": "Android (Chrome) :",
  "settings.pwaAndroidSteps": "Menu → Installer l'application.",
  "settings.pwaDesktop": "Ordinateur :",
  "settings.pwaDesktopSteps": "Utilisez l'invite d'installation du navigateur dans la barre d'adresse.",
  "settings.pwaIos": "iOS (Safari) :",
  "settings.pwaIosSteps": "Appuyez sur Partager → Ajouter à l'écran d'accueil.",
  "settings.saveProfile": "Enregistrer le profil",
  "settings.storedLocally": "Les paramètres sont enregistrés localement jusqu'à ce que la synchronisation du profil soit disponible.",
  "settings.weeklyEmailSummary": "Récapitulatif hebdomadaire par e-mail",
  "users.applicationDetails": "Détails de la candidature",
  "users.applicationReview": "Examen de la candidature :",
  "users.applicationStatus": "Statut de la candidature",
  "users.approve": "Approuver",
  "users.approveApplication": "Approuver la candidature",
  "users.backToApplications": "Retour aux candidatures",
  "users.colApplicant": "Candidat",
  "users.colRole": "Rôle",
  "users.dateAdded": "Date d'ajout",
  "users.directoryFound": "Trouvé dans la table employees_personal_info.",
  "users.directoryMatch": "Correspondance dans l'annuaire",
  "users.directoryName": "Nom dans l'annuaire",
  "users.email": "E-mail",
  "users.filterAll": "Toutes les candidatures",
  "users.filterPending": "En attente d'examen",
  "users.nextSteps": "Prochaines étapes",
  "users.noApplications": "Aucune candidature trouvée",
  "users.phone": "Téléphone",
  "users.phoneNumber": "Numéro de téléphone",
  "users.reject": "Rejeter",
  "users.rejectApplication": "Rejeter la candidature",
  "users.requestedRole": "Rôle demandé",
  "users.review": "Examiner",
  "users.statusRejected": "Rejeté",
  "users.stepBackgroundCheck": "Lancer la vérification des antécédents",
  "users.stepCheckLicense": "Vérifier la validité de la licence/certification",
  "users.stepScheduleInterview": "Planifier un entretien si approuvé",
  "users.stepVerifyReferences": "Vérifier les références par téléphone",
  "users.submitted": "Soumis :",
  "widget.aiSummary": "Résumé IA",
  "widget.barChart": "Graphique à barres",
  "widget.comparison": "Comparaison",
  "widget.dataTable": "Tableau de données",
  "widget.dayOfWeek": "Jour de la semaine",
  "widget.image": "Image",
  "widget.kpiRow": "Ligne de KPI",
  "widget.lineChart": "Graphique linéaire",
  "widget.metricCard": "Carte de métrique",
  "widget.pieDonut": "Camembert / Anneau",
  "widget.rankedTable": "Tableau classé",
  "widget.textBlock": "Bloc de texte",

  // Activity calendar
  "calendar.title": "Calendrier d'activité des patrouilles",
  "calendar.subtitle": "Activité de scan à chaque point de contrôle, jour par jour",
  "calendar.viewMonth": "Mois",
  "calendar.viewWeek": "Semaine",
  "calendar.viewDay": "Jour",
  "calendar.viewList": "Liste",
  "calendar.today": "Aujourd'hui",
  "calendar.allHospitals": "Tous les hôpitaux",
  "calendar.totalScans": "{n} scans",
  "calendar.activeDays": "{n} jours actifs",
  "calendar.alertsCount": "{n} alertes",
  "calendar.noActivityRange": "Aucune activité de scan sur cette période.",
  "calendar.loading": "Chargement de l'activité…",
  "calendar.loadFailed": "Échec du chargement de l'activité",
  "calendar.refresh": "Actualiser",
  "calendar.colTime": "Heure",
  "calendar.colHospital": "Hôpital",
  "calendar.colCheckpoint": "Point de contrôle",
  "calendar.colDevice": "Appareil",
  "calendar.colGuard": "Agent",
  "calendar.violation": "Infraction",
  "calendar.violationsCount": "{n} infractions",
  "calendar.scansShort": "{n} scans",
  "calendar.hospitalsActive": "{n} hôpitaux actifs",
  "calendar.moreEvents": "+{n} de plus",
  "calendar.weekOf": "Semaine du {date}",
  "calendar.dayEvents": "Événements de scan",
  "calendar.hourlyDistribution": "Répartition horaire",
  "calendar.legendLess": "Moins",
  "calendar.legendMore": "Plus",
  "calendar.unknownHospital": "Hôpital inconnu",
  "calendar.unknownGuard": "Agent inconnu",
  "calendar.unknownCheckpoint": "Point de contrôle inconnu",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "Conformité",
  "nav.officers": "Agents",
  "nav.patrolReports": "Rapports de patrouille",
  "common.retry": "Réessayer",
  "common.collapse": "Réduire",
  "common.expand": "Développer",
  "home.comparisonVsMapNote": "Les décomptes incluent chaque scan enregistré. La Carte des scans n'affiche que les scans avec coordonnées GPS, son total peut donc être inférieur.",
  "live.colOfficer": "Agent",
  "live.unattributed": "Non attribué",
  "map.trailNote": "Les points sont colorés selon l'heure de scan. Aucun tracé n'est dessiné entre les scans — seuls les emplacements de scan enregistrés sont affichés.",
  "checkpoints.directoryTitle": "Annuaire des points de contrôle",
  "checkpoints.directorySubtitle": "Chaque point de contrôle QR enregistré, organisé par étage",
  "checkpoints.searchPlaceholder": "Rechercher par nom, code ou bâtiment…",
  "checkpoints.countShown": "{n} points de contrôle",
  "checkpoints.exportCsv": "Exporter CSV",
  "checkpoints.loadingDirectory": "Chargement des points de contrôle…",
  "checkpoints.empty": "Aucun point de contrôle trouvé pour cet hôpital.",
  "checkpoints.noFloor": "Non attribué",
  "checkpoints.floorLabel": "Étage {n}",
  "checkpoints.colCode": "Code",
  "checkpoints.colName": "Nom",
  "checkpoints.colBuilding": "Bâtiment",
  "checkpoints.colFloor": "Étage",
  "checkpoints.colLastScanned": "Dernier scan",
  "checkpoints.colTotalScans": "Total des scans",
  "checkpoints.colStatus": "Statut",
  "checkpoints.active": "Actif",
  "checkpoints.inactive": "Inactif",
  "checkpoints.never": "Jamais",
  "checkpoints.untitled": "Point de contrôle sans titre",
  "checkpoints.totalScans": "Total des scans",
  "checkpoints.compliance": "Conformité",
  "checkpoints.late": "En retard",
  "checkpoints.missed": "Manqué",
  "checkpoints.fromDate": "Du",
  "checkpoints.toDate": "Au",
  "checkpoints.clearDates": "Effacer",
  "checkpoints.loadingHistory": "Chargement de l'historique des scans…",
  "checkpoints.noScans": "Aucun scan enregistré pour ce point de contrôle dans la plage sélectionnée.",
  "checkpoints.unknownDevice": "Appareil inconnu",
  "checkpoints.noGps": "Aucun GPS",
  "checkpoints.statusOnTime": "À l'heure",
  "checkpoints.statusLate": "En retard",
  "checkpoints.statusMissed": "Manqué",
  "checkpoints.viewHistory": "Voir l'historique des scans",
  "compliance.title": "Conformité des patrouilles",
  "compliance.subtitle": "Statut de scan des points de contrôle par rapport à l'intervalle configuré de chaque emplacement.",
  "compliance.advisory": "À titre informatif uniquement. Cette vue indique quand chaque point de contrôle a été scanné pour la dernière fois et le temps restant dans son intervalle de scan. Il ne s'agit ni d'une affectation de travail, ni d'un itinéraire, ni d'une instruction. Les points de contrôle scannés et leur ordre restent à la décision de l'agent et de son superviseur, sous réserve des consignes de poste de leur employeur et de toute tâche prioritaire.",
  "compliance.loadFailed": "Impossible de charger le statut de conformité",
  "compliance.overdue": "En retard",
  "compliance.overdueSub": "Intervalle de scan dépassé",
  "compliance.dueSoon": "Bientôt dû",
  "compliance.dueSoonSub": "Dans le dernier quart de l'intervalle",
  "compliance.onInterval": "Dans l'intervalle",
  "compliance.onIntervalSub": "Scanné dans l'intervalle",
  "compliance.neverScanned": "Aucun scan enregistré",
  "compliance.neverScannedSub": "Non compté comme en retard",
  "compliance.neverScannedNoteTitle": "Pourquoi ceux-ci ne sont pas comptés comme en retard :",
  "compliance.neverScannedNote": "Un point de contrôle sans scan enregistré n'a aucun intervalle à avoir dépassé. Les points de contrôle antérieurs au suivi de conformité apparaissent ainsi jusqu'à ce que le remplissage historique ait été exécuté pour le site ; les considérer comme en retard déclencherait une alerte pour chaque point de contrôle en même temps.",
  "compliance.openAlerts": "Alertes de conformité ouvertes",
  "compliance.checkpointStatus": "Statut des points de contrôle",
  "compliance.filterAttention": "En retard et bientôt dû",
  "compliance.filterOverdue": "En retard uniquement",
  "compliance.filterAll": "Tous les points de contrôle",
  "compliance.emptyAll": "Aucun point de contrôle trouvé pour cette sélection.",
  "compliance.emptyAttention": "Aucun point de contrôle n'est en retard ou bientôt dû.",
  "compliance.colCheckpoint": "Point de contrôle",
  "compliance.colStatus": "Statut",
  "compliance.colLastScan": "Dernier scan",
  "compliance.colInterval": "Intervalle",
  "compliance.colRemaining": "Temps dans l'intervalle",
  "compliance.colScans24h": "Scans (24 h)",
  "compliance.status.OVERDUE": "En retard",
  "compliance.status.DUE_SOON": "Bientôt dû",
  "compliance.status.OK": "Dans l'intervalle",
  "compliance.status.NEVER_SCANNED": "Aucun scan enregistré",
  "compliance.minutesShort": "min",
  "compliance.perDay": "par jour",
  "compliance.ruleLocation": "règle d'emplacement",
  "compliance.ruleHospital": "valeur par défaut du site",
  "compliance.truncated": "Affichage des résultats les plus urgents uniquement. Affinez par site pour voir le reste.",
  "compliance.generatedAt": "Statut au",
  "compliance.rules": "Intervalles de scan",
  "compliance.rulesTitle": "Intervalles de scan",
  "compliance.rulesSubtitle": "Une règle d'emplacement prévaut sur la valeur par défaut du site, qui prévaut sur la valeur par défaut du système.",
  "compliance.rulesEmpty": "Aucune règle personnalisée — la valeur par défaut du système s'applique.",
  "compliance.rulesLoadFailed": "Impossible de charger les règles",
  "compliance.rulesSaveFailed": "Impossible d'enregistrer la règle",
  "compliance.rulesDeleteFailed": "Impossible de supprimer la règle",
  "compliance.rulesCreateFailed": "Impossible de créer la règle",
  "compliance.rulesInvalid": "L'intervalle et le minimum quotidien doivent être des nombres",
  "compliance.systemDefault": "Valeur par défaut du système",
  "compliance.systemDefaultValue": "toutes les",
  "compliance.systemDefaultNote": "Les sites sans règle propre sont évalués par rapport à cette valeur.",
  "compliance.siteWide": "Tous les points de contrôle de ce site",
  "compliance.colAppliesTo": "S'applique à",
  "compliance.colIntervalMin": "Intervalle (min)",
  "compliance.colMinPerDay": "Min / 24 h",
  "compliance.colActions": "Actions",
  "compliance.addSiteDefault": "Ajouter une valeur par défaut de site",
  "compliance.pickSiteToAdd": "Sélectionnez un seul site pour lui ajouter une valeur par défaut.",
  "officers.title": "Agents",
  "officers.subtitle": "Agents qui prennent leur service avec un numéro N afin que leurs scans leur soient attribués. Il ne s'agit pas d'identifiants du tableau de bord.",
  "officers.add": "Ajouter un agent",
  "officers.addTitle": "Ajouter un agent",
  "officers.editTitle": "Modifier l'agent",
  "officers.loadFailed": "Impossible de charger les agents",
  "officers.saveFailed": "Impossible d'enregistrer l'agent",
  "officers.deactivateFailed": "Impossible de désactiver l'agent",
  "officers.searchPlaceholder": "Rechercher par nom, numéro N ou e-mail",
  "officers.filterActive": "Actif",
  "officers.filterInactive": "Inactif",
  "officers.filterSuspended": "Suspendu",
  "officers.filterPending": "En attente d'approbation",
  "officers.filterRejected": "Rejeté",
  "officers.filterAll": "Tous les statuts",
  "officers.onShiftCount": "Actuellement en service :",
  "officers.empty": "Aucun agent pour l'instant. Ajoutez-en un pour commencer à attribuer les scans.",
  "officers.emptySearch": "Aucun agent ne correspond à cette recherche.",
  "officers.colOfficer": "Agent",
  "officers.colNNumber": "Numéro N",
  "officers.colSite": "Site",
  "officers.colStatus": "Statut",
  "officers.colShift": "Service actuel",
  "officers.colActions": "Actions",
  "officers.status.ACTIVE": "Actif",
  "officers.status.PENDING": "En attente d'approbation",
  "officers.status.INACTIVE": "Inactif",
  "officers.status.SUSPENDED": "Suspendu",
  "officers.status.REJECTED": "Rejeté",
  "officers.onShiftSince": "En service depuis",
  "officers.offShift": "Pas en service",
  "officers.scans": "scans",
  "officers.deactivate": "Désactiver",
  "officers.deactivateTitle": "Désactiver l'agent ?",
  "officers.deactivateBody": "{name} ne pourra plus prendre son service, et tout service en cours est clôturé. Son historique de scans est conservé et lui reste attribué.",
  "officers.fieldNNumber": "Numéro N",
  "officers.fieldNNumberHint": "Le N initial est ajouté automatiquement si vous l'omettez.",
  "officers.fieldName": "Nom complet",
  "officers.fieldSite": "Site",
  "officers.fieldEmail": "E-mail",
  "officers.fieldPhone": "Téléphone",
  "officers.fieldStatus": "Statut",
  "officers.fieldStatusHint": "Seuls les agents ACTIFS peuvent prendre leur service. Tout changement depuis ACTIF clôture le service en cours.",
  "officers.selectSite": "Sélectionner un site",
  "officers.formRequired": "Le numéro N, le nom et le site sont obligatoires",
  "officers.pendingTitle": "Approbations d'inscription en attente",
  "officers.selfEnrolled": "Auto-inscrit",
  "officers.enrolledAt": "prise de service",
  "officers.enrollDistance": "{d} de la zone de scan enregistrée du site",
  "officers.enrollNoGps": "aucune position GPS à la prise de service",
  "officers.enrollSiteMismatch": "{chosen} sélectionné, mais le GPS indiquait {gps} — confirmez lequel est correct avant d'approuver.",
  "officers.pendingNote": "Ces identités ont été auto-déclarées lors d'un scan de badge. Leurs scans sont attribués à titre provisoire jusqu'à l'approbation ; le rejet conserve l'enregistrement et ses scans pour examen.",
  "officers.approve": "Approuver",
  "officers.reject": "Rejeter",
  "officers.approveTitle": "Approuver l'inscription ?",
  "officers.approveBody": "Confirme {n} comme agent à {site}. Ses scans en attente restent attribués et les futures prises de service fonctionnent normalement.",
  "officers.approveName": "Nom de l'agent (tel qu'il doit apparaître)",
  "officers.approveFailed": "Impossible d'approuver l'inscription",
  "officers.rejectFailed": "Impossible de rejeter l'inscription",
  "patrolReports.title": "Rapports de patrouille",
  "patrolReports.subtitle": "Activité de patrouille enregistrée par agent, couverture des points de contrôle et historique des alertes de conformité.",
  "patrolReports.tabOfficers": "Agents",
  "patrolReports.tabCoverage": "Couverture",
  "patrolReports.tabHistory": "Historique des alertes",
  "patrolReports.loadFailed": "Impossible de charger le rapport",
  "patrolReports.badRange": "La date de début doit être antérieure ou égale à la date de fin",
  "patrolReports.startDate": "Date de début",
  "patrolReports.endDate": "Date de fin",
  "patrolReports.totalScans": "Scans sur la période",
  "patrolReports.attributed": "Attribués à un agent",
  "patrolReports.unattributed": "Non attribués",
  "patrolReports.unattributedSub": "Scannés alors qu'aucun agent n'était en service",
  "patrolReports.officersListed": "Agents répertoriés",
  "patrolReports.noOfficers": "Aucun agent dans cette sélection.",
  "patrolReports.colOfficer": "Agent",
  "patrolReports.colSite": "Site",
  "patrolReports.colShifts": "Services",
  "patrolReports.colShiftTime": "Temps de service",
  "patrolReports.colScans": "Scans",
  "patrolReports.colCheckpoints": "Points de contrôle",
  "patrolReports.colScansHr": "Scans / h",
  "patrolReports.colLastScan": "Dernier scan",
  "patrolReports.fullyCovered": "Couvert chaque jour",
  "patrolReports.partiallyCovered": "Couvert certains jours",
  "patrolReports.uncovered": "Aucun scan sur la période",
  "patrolReports.of": "sur",
  "patrolReports.coverageTitle": "Couverture des points de contrôle",
  "patrolReports.coverageSort": "Points de contrôle les moins couverts en premier.",
  "patrolReports.colCheckpoint": "Point de contrôle",
  "patrolReports.colDaysCovered": "Jours couverts",
  "patrolReports.colExpected": "Attendu",
  "patrolReports.colStatusNow": "Statut actuel",
  "patrolReports.alertsRaised": "Alertes sur la période",
  "patrolReports.alertsOpen": "Encore ouvertes",
  "patrolReports.alertsResolved": "Résolues",
  "patrolReports.repeatTitle": "Points de contrôle générant le plus souvent des alertes",
  "patrolReports.colAlerts": "Alertes",
  "patrolReports.colOpen": "Ouvertes",
  "patrolReports.colWorst": "Pire retard",
  "patrolReports.colAvgResolve": "Délai moyen de résolution",
  "patrolReports.colLatest": "Plus récente",
  "patrolReports.alertLog": "Journal des alertes",
  "patrolReports.noAlerts": "Aucune alerte sur cette période.",
  "patrolReports.resolvedIn": "résolue en",
  "patrolReports.stateResolved": "Résolue",
  "patrolReports.stateOpen": "Ouverte",
  "emailPrefs.title": "Préférences d'alertes par e-mail",
  "emailPrefs.subtitle": "Choisissez quels e-mails de conformité vous recevez, par site.",
  "emailPrefs.loadFailed": "Impossible de charger les préférences d'e-mail",
  "emailPrefs.saveFailed": "Impossible d'enregistrer la préférence",
  "emailPrefs.noSites": "Aucun site dans votre liste d'accès.",
  "emailPrefs.noPreference": "Aucune préférence enregistrée — la valeur de repli s'applique",
  "emailPrefs.explainer": "Les sites où personne n'a enregistré de préférence envoient par défaut un e-mail à tous les superviseurs et directeurs. Enregistrer une préférence sur un site le fait passer aux choix explicites uniquement.",
  "emailPrefs.overdue": "Alertes de retard",
  "emailPrefs.overdueHint": "E-mail immédiat lorsque des points de contrôle dépassent leur intervalle de scan",
  "emailPrefs.daily": "Récapitulatif quotidien",
  "emailPrefs.dailyHint": "Un résumé de conformité par jour",
  "emailPrefs.officerSummary": "Résumé d'activité des agents",
  "emailPrefs.officerSummaryHint": "Rapport hebdomadaire d'activité enregistrée. Désactivé sauf adhésion.",
  "emailPrefs.manageOthers": "Gérer les destinataires de ce site",
  "emailPrefs.noOthers": "Aucun autre destinataire configuré ici.",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "Nom (facultatif)",
  "emailPrefs.enroll": "Ajouter un destinataire",
  "emailPrefs.officerSummaryNote": "Le résumé d'activité des agents est un rapport programmé de l'activité de scan enregistrée, avec ses réserves — ce n'est pas une note de performance, et il n'est jamais envoyé à quiconque n'y a pas adhéré.",
  "officerMap.open": "Voir la carte de l'historique des scans",
  "officerMap.title": "Historique des scans",
  "officerMap.loadFailed": "Impossible de charger l'historique des scans",
  "officerMap.empty": "Aucun scan géolocalisé attribué à cet agent sur la période sélectionnée.",
  "officerMap.firstScan": "Premier scan",
  "officerMap.lastScan": "Dernier scan",
  "officerMap.scans": "scans",
  "officerMap.ofTotal": "sur {n} scans",
  "officerMap.note": "Seuls les scans attribués à cet agent apparaissent ici. Les scans effectués hors service sont non attribués et ne sont pas affichés.",
  "patrolReports.officersTableTitle": "Activité enregistrée par agent",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "Tous les agents",
  "officerDetail.backToOfficers": "Retour aux agents",
  "officerDetail.notFound": "Agent introuvable.",
  "officerDetail.loadFailed": "Impossible de charger l'agent",
  "officerDetail.selfEnrolled": "Auto-inscrit",
  "officerDetail.addedBySupervisor": "Ajouté par un superviseur",
  "officerDetail.memberSince": "membre depuis {date}",
  "officerDetail.totalScans": "Total des scans",
  "officerDetail.shifts": "Services",
  "officerDetail.activeDays": "Jours actifs",
  "officerDetail.avgShift": "Moy. / service",
  "officerDetail.noShiftsYet": "aucun service pour l'instant",
  "officerDetail.scansPerShift": "scans par service",
  "officerDetail.lastActive": "Dernière activité",
  "officerDetail.whereScanned": "Où {name} a scanné",
  "officerDetail.mapToLight": "Passer la carte en tuiles claires",
  "officerDetail.mapToDark": "Passer la carte en tuiles sombres",
  "officerDetail.light": "Clair",
  "officerDetail.dark": "Sombre",
  "officerDetail.noGpsScans": "Aucun scan géolocalisé à afficher sur la carte au cours des 30 derniers jours.",
  "officerDetail.scanActivityTitle": "Activité de scan — {n} derniers jours",
  "officerDetail.noScansInDays": "Aucun scan enregistré au cours des {n} derniers jours.",
  "officerDetail.scanHistory": "Historique des scans",
  "officerDetail.searchScans": "Rechercher des scans…",
  "officerDetail.colDateTime": "Date et heure",
  "officerDetail.colLocation": "Emplacement",
  "officerDetail.colHospital": "Hôpital",
  "officerDetail.colCoordinates": "Coordonnées",
  "officerDetail.noScansMatch": "Aucun scan ne correspond à « {q} ».",
  "officerDetail.showingScans": "Affichage de {shown} sur {total} scans enregistrés (30 derniers jours).",
  "officerDetail.timelineRange": "{n} scans · du plus ancien → au plus récent",
  "officerDetail.hoverTimeline": "Survolez la chronologie pour tracer un scan",
  "officerDetail.timelineCaption": "Chaque point représente un scan, placé selon le moment où il s'est produit et coloré du bleu (plus ancien) au rouge (plus récent). Survolez pour le mettre en évidence sur la carte. Aucun tracé n'est dessiné entre les scans — seuls les emplacements de scan enregistrés sont affichés.",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "Agent",
  "map.clearOfficer": "Effacer le filtre d'agent",
  "map.searchOfficer": "Rechercher un agent…",
  "map.misplacedTitle": "Afficher uniquement les scans dont le GPS s'est retrouvé à plus de 1 km de leur point de contrôle",
  "map.misplacedOn": "Mal placés",
  "map.misplacedOff": "Mal placés",
  "map.anomaliesTitle": "Afficher les scans signalés comme anormaux — déplacement impossible de l'agent, ou scan positionné loin de son propre hôpital",
  "map.anomalies": "Anomalies",
  "map.popupOfficer": "Agent :",
  "map.anomalousMovement": "Anormal — déplacement impossible entre les scans de cet agent",
  "map.anomalousHospital": "Anormal — positionné loin de l'hôpital indiqué",
  "map.anomalousBoth": "Anormal — déplacement impossible et loin de son hôpital",
  "map.metersFromCheckpoint": "{n} m de son point de contrôle",
  "map.scansLabel": "scans",
  "map.earliest": "Le plus ancien",
  "map.latest": "Le plus récent",

};

export default fr;
